import { Outlet, useNavigate } from 'react-router-dom'

import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { EClientPath } from '~/models/api'

function ProtectedFromPartnerRouteGuard() {
  const navigate = useNavigate()
  const isPartner = useIsPartner()

  if (isPartner) {
    navigate(EClientPath.overview, { replace: true })
    return null
  }

  return <Outlet />
}

export default ProtectedFromPartnerRouteGuard
